export default "__VITE_ASSET__DiZz42pk__"